import {Accounts} from '@features/accounts/Accounts';

const AccountsPage = () => {
    return <Accounts />;
};

export default AccountsPage;
